import axios from "axios";
import { getStore } from "../redux/_store/index";
import { Auth } from "aws-amplify";
import { TOKEN } from "../redux/_types/authType";
import env from "../configs/Ambiente";
const { url_services } = require("../configs/Ambiente.json")[env];

const axiosInstance = axios.create({
  baseURL: url_services,
  responseType: "json",
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Interceptor de request: Inyecta el token de autorización
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      config.headers = config.headers || {};
      const { token } = getStore().getState().auth;
      if (token) {
        config.headers.Authorization = token;
      }
    } catch (error) {
      console.warn("Error obteniendo token del store:", error);
    }
    return config;
  },
  (error) => {
    console.error("Error en configuración de request:", error);
    return Promise.reject(error);
  }
);

// Interceptor de response: Maneja errores y refresh token en 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const statusCode = error.response?.status;
    
    // Manejo de 401 con refresh token automático
    if (statusCode === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log("🔄 Token expirado, intentando refrescar...");
        
        const user = await Auth.currentAuthenticatedUser();
        const session = await Auth.currentSession();
        const newToken = session.getIdToken().getJwtToken();
        
        console.log("✅ Token refrescado exitosamente");
        
        getStore().dispatch({
          type: TOKEN,
          payload: newToken,
        });
        
        originalRequest.headers.Authorization = newToken;
        processQueue(null, newToken);
        isRefreshing = false;
        
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("❌ Error al refrescar token:", refreshError);
        processQueue(refreshError, null);
        isRefreshing = false;
        
        try {
          await Auth.signOut();
          localStorage.clear();
          window.location.href = "/login";
        } catch (signOutError) {
          console.error("Error durante logout:", signOutError);
        }
        
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

// Exportar servicio legacy para compatibilidad
export const axiosService = async ({
  type,
  url,
  body = null,
  responseType = "json",
  success = null,
  fail = null,
}) => {
  try {
    const response = await axiosInstance({
      method: type,
      url: url,
      data: body,
      responseType,
    });
    if (success) return success(response);
    return response;
  } catch (error) {
    if (fail) return fail(error);
    throw error;
  }
};

export default axiosInstance;
